import { Property } from '@/types/index';

export const FLIP_DEFAULTS = {
  flipFacteurVente:    0.65,
  flipBudgetCuisine:   15000,
  flipBudgetSalleBain: 12000,
  flipCoutMenuiserie:  2000,
  flipCoutSol:         80,
  flipCoutElectricite: 50,
  flipMargeVoulue:     10,
  flipFraisAchat:      5,
  flipFraisRevente:    3,
  flipFraisEmprunt:    2,
};

export type FlipStatus = 'green' | 'orange' | 'red';

export function computeFlipStatus(p: Property): FlipStatus | null {
  const surface    = p.area        ?? 0;
  const prixAchat  = p.askingPrice ?? 0;
  const prixMarche = p.flipPrixMarcheM2 ?? p.marketPricePerM2 ?? 0;
  if (surface === 0 || prixAchat === 0 || prixMarche === 0) return null;

  const rooms       = p.rooms ?? 0;
  const facteur     = p.flipFacteurVente    ?? FLIP_DEFAULTS.flipFacteurVente;
  const cuisine     = p.flipBudgetCuisine   ?? FLIP_DEFAULTS.flipBudgetCuisine;
  const salleBain   = p.flipBudgetSalleBain ?? FLIP_DEFAULTS.flipBudgetSalleBain;
  const menuiserie  = p.flipCoutMenuiserie  ?? FLIP_DEFAULTS.flipCoutMenuiserie;
  const sol         = p.flipCoutSol         ?? FLIP_DEFAULTS.flipCoutSol;
  const electricite = p.flipCoutElectricite ?? FLIP_DEFAULTS.flipCoutElectricite;
  const margeVoulue = p.flipMargeVoulue     ?? FLIP_DEFAULTS.flipMargeVoulue;
  const fraisAchat  = p.flipFraisAchat      ?? FLIP_DEFAULTS.flipFraisAchat;
  const fraisRevente  = p.flipFraisRevente  ?? FLIP_DEFAULTS.flipFraisRevente;
  const fraisEmprunt  = p.flipFraisEmprunt  ?? FLIP_DEFAULTS.flipFraisEmprunt;

  // Même formule que FlipAnalysisTab.tsx
  const prixVentePotentiel  = Math.round(surface * prixMarche * facteur);
  const fraisReventeMontant = Math.round(prixVentePotentiel * fraisRevente / 100);
  const prixVenteNet        = prixVentePotentiel - fraisReventeMontant;
  const totalRenovation     = cuisine + salleBain
    + Math.round(menuiserie * rooms)
    + Math.round(sol * surface)
    + Math.round(electricite * surface);
  const margeSouhaitee = Math.round(prixVentePotentiel * margeVoulue / 100);
  const prixAchatMax   = prixVenteNet > 0
    ? Math.round(
        (prixVenteNet - margeSouhaitee - totalRenovation * (1 + fraisEmprunt / 100))
        / (1 + fraisAchat / 100)
      )
    : null;
  if (prixAchatMax == null || prixAchatMax <= 0) return 'red';

  const ecartPrix = (prixAchat - prixAchatMax) / prixAchatMax * 100;
  return ecartPrix <= 0 ? 'green' : ecartPrix <= 20 ? 'orange' : 'red';
}
